/**
 * src/components/shared/lightbox.js
 *
 * Lightbox singleton. Uso: openLightbox(images, startIndex)
 * Se monta una sola vez en el body y se reutiliza.
 */

let overlay, img, counter, closeBtn, prevBtn, nextBtn
let images = [], current = 0

function build() {
    if (overlay) return

    overlay = document.createElement('div')
    overlay.className = 'lb-overlay'
    overlay.setAttribute('role', 'dialog')
    overlay.setAttribute('aria-modal', 'true')

    img = document.createElement('img')
    img.className = 'lb-img'

    counter = document.createElement('span')
    counter.className = 'lb-counter'

    closeBtn = document.createElement('button')
    closeBtn.className = 'lb-btn lb-btn--close'
    closeBtn.setAttribute('aria-label', 'Cerrar')
    closeBtn.textContent = '✕'

    prevBtn = document.createElement('button')
    prevBtn.className = 'lb-btn lb-btn--prev'
    prevBtn.setAttribute('aria-label', 'Anterior')
    prevBtn.textContent = '‹'

    nextBtn = document.createElement('button')
    nextBtn.className = 'lb-btn lb-btn--next'
    nextBtn.setAttribute('aria-label', 'Siguiente')
    nextBtn.textContent = '›'

    const inner = document.createElement('div')
    inner.className = 'lb-inner'
    inner.appendChild(img)

    overlay.appendChild(closeBtn)
    overlay.appendChild(prevBtn)
    overlay.appendChild(nextBtn)
    overlay.appendChild(inner)
    overlay.appendChild(counter)
    document.body.appendChild(overlay)

    closeBtn.addEventListener('click', closeLightbox)
    overlay.addEventListener('click', e => { if (e.target === overlay) closeLightbox() })
    prevBtn.addEventListener('click', () => navigate(-1))
    nextBtn.addEventListener('click', () => navigate(1))

    document.addEventListener('keydown', e => {
        if (!overlay.classList.contains('lb-overlay--open')) return
        if (e.key === 'Escape')     closeLightbox()
        if (e.key === 'ArrowLeft')  navigate(-1)
        if (e.key === 'ArrowRight') navigate(1)
    })
}

function navigate(dir) {
    current = (current + dir + images.length) % images.length
    render()
}

function render() {
    img.src = images[current]
    counter.textContent = `${current + 1} / ${images.length}`
    prevBtn.style.display = images.length > 1 ? '' : 'none'
    nextBtn.style.display = images.length > 1 ? '' : 'none'
}

export function openLightbox(imgs, startIndex = 0) {
    build()
    images  = imgs
    current = startIndex
    render()
    overlay.classList.add('lb-overlay--open')
    document.body.classList.add('no-scroll')
}

export function closeLightbox() {
    overlay.classList.remove('lb-overlay--open')
    document.body.classList.remove('no-scroll')
}
